var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.501 9.25L17.451 19.7475C17.2922 21.3388 17.2135 22.1338 16.851 22.735C16.533 23.2643 16.0655 23.6875 15.5072 23.9513C14.8735 24.25 14.076 24.25 12.476 24.25H9.52598C7.92723 24.25 7.12848 24.25 6.49473 23.95C5.93604 23.6864 5.46799 23.2632 5.14973 22.7338C4.78973 22.1338 4.70973 21.3388 4.54973 19.7475L3.50098 9.25M12.876 17.375V11.125M9.12598 17.375V11.125M1.62598 6.125H7.39473M7.39473 6.125L7.87723 2.785C8.01723 2.1775 8.52223 1.75 9.10223 1.75H12.8997C13.4797 1.75 13.9835 2.1775 14.1247 2.785L14.6072 6.125M7.39473 6.125H14.6072M14.6072 6.125H20.376",
    stroke: "black",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteAdmin);
export default __webpack_public_path__ + "static/media/deleteAdmin.a87339a03bfcc555961dba0dfa04fd7e.svg";
export { ForwardRef as ReactComponent };